/**
 * The last response per request, kept in memory for the tab's lifetime so a page opened again
 * shows its data at once while it refetches. Bounded: the oldest entry goes first, which keeps the
 * browsing of many filter combinations from growing it without limit.
 */
const MAX_ENTRIES = 50
const entries = new Map<string, unknown>()
let generation = 0

/** Changes on every clear, so a request started before a logout can tell not to write. */
export function cacheGeneration() {
  return generation
}

export function readCached<R>(key: string): R | undefined {
  // The Map is filled only by writeCached with the same key, which useData builds from the same
  // path and params its response type belongs to.
  return entries.get(key) as R | undefined
}

export function writeCached(key: string, value: unknown) {
  entries.delete(key)
  entries.set(key, value)
  if (entries.size > MAX_ENTRIES) {
    for (const oldest of entries.keys()) {
      entries.delete(oldest)
      break
    }
  }
}

export function deleteCached(key: string) {
  entries.delete(key)
}

export function clearDataCache() {
  entries.clear()
  generation++
}
